import api from './api';
import {
  CreateJiraPresetDto,
  JiraPreset,
  JiraPullResult,
  JiraPushResult,
  UpdateJiraPresetDto,
} from '../types/jira.types';

export const JiraService = {
  getPresets: async (tableId: string): Promise<JiraPreset[]> => {
    const response = await api.get<JiraPreset[]>(`/tables/${tableId}/jira/presets`);
    return response.data;
  },

  createPreset: async (tableId: string, dto: CreateJiraPresetDto): Promise<JiraPreset> => {
    const response = await api.post<JiraPreset>(`/tables/${tableId}/jira/presets`, dto);
    return response.data;
  },

  updatePreset: async (
    tableId: string,
    presetId: string,
    dto: UpdateJiraPresetDto,
  ): Promise<JiraPreset> => {
    const response = await api.put<JiraPreset>(`/tables/${tableId}/jira/presets/${presetId}`, dto);
    return response.data;
  },

  deletePreset: async (tableId: string, presetId: string): Promise<void> => {
    await api.delete(`/tables/${tableId}/jira/presets/${presetId}`);
  },

  push: async (tableId: string, dataId: string, presetId: string): Promise<JiraPushResult> => {
    const response = await api.post<JiraPushResult>(`/tables/${tableId}/jira/push`, {
      dataId,
      presetId,
    });
    return response.data;
  },

  pull: async (tableId: string, dataId: string, presetId: string): Promise<JiraPullResult> => {
    const response = await api.post<JiraPullResult>(`/tables/${tableId}/jira/pull`, {
      dataId,
      presetId,
    });
    return response.data;
  },
};